<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-card>
        <v-img
          @click="Home()"
          :lazy-src="require('@/assets/Icon/Back.jpg')"
          max-height="30"
          max-width="100"
          :src="require('@/assets/Icon/Back.jpg')"
        ></v-img>
      </v-card>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-dialog v-model="dialogForm" fullscreen>
              <v-toolbar color="indigo" dark>
                <v-toolbar-title>ขอโอที</v-toolbar-title>
                <v-icon class="ml-2"> mdi-clock-alert-outline </v-icon>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="(dialogForm = false), clearData()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #1b437c">
                          <th class="text-left">ข้อมูล</th>
                          <th class="text-left">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>วันที่</td>
                          <td>{{ item_Info.masShiftTypeNameDay }}</td>
                        </tr>
                        <tr>
                          <td>ประเภทกะ</td>
                          <td>{{ item_Info.shiftCode }}</td>
                        </tr>
                        <tr>
                          <td>กะเข้างาน</td>
                          <td>{{ item_Info.masShiftTypeStartTime }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเข้างาน</td>
                          <td>{{ item_Info.checkInDay }}</td>
                        </tr>
                        <tr>
                          <td>กะเลิกงาน</td>
                          <td>{{ item_Info.masShiftTypeEndTime }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเลิกงาน</td>
                          <td>{{ item_Info.checkOutDay }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>

                <v-divider style="background-color: #ffffff"></v-divider>

                <v-card-text class="pa-2 ma-2" cols="12">
                  <v-col
                    cols="12"
                    v-if="item_Info.leaveSummaryDayName != 'ครึ่งวันเช้า'"
                  >
                    <v-checkbox
                      class="pa-0 ma-0"
                      :disabled="item_Info.lateStatus === 'สาย'"
                      label="ขอโอทีก่อนเวลาทำงาน"
                      v-model="formRequest.ot_before_check_in_status"
                    ></v-checkbox>
                    <v-select
                      class="pa-0 ma-0"
                      :items="itemsTime"
                      v-model="formRequest.request_ot_time_before"
                      :disabled="!formRequest.ot_before_check_in_status"
                      clearable
                      clear-icon="mdi-close-circle"
                      outlined
                      dense
                      label="เวลา"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="item_Info.leaveSummaryDayName != 'ครึ่งวันบ่าย'"
                  >
                    <v-checkbox
                      class="pa-0 ma-0"
                      label="ขอโอทีหลังเวลาทำงาน"
                      required
                      v-model="formRequest.ot_after_check_out_status"
                    ></v-checkbox>
                    <v-select
                      class="pa-0 ma-0"
                      :items="itemsTime"
                      v-model="formRequest.request_ot_time_after"
                      clearable
                      clear-icon="mdi-close-circle"
                      :disabled="!formRequest.ot_after_check_out_status"
                      outlined
                      dense
                      label="เวลา"
                    ></v-select>
                  </v-col>
                </v-card-text>

                <v-divider style="background-color: #ffffff"></v-divider>

                <v-form
                  ref="form_update"
                  v-model="valid_update"
                  lazy-validation
                >
                  <v-card-text class="pl-6">
                    <v-textarea
                      maxlength="100"
                      rows="3"
                      row-height="25"
                      outlined
                      v-model="formRequest.otRemark"
                      clearable
                      clear-icon="mdi-close-circle"
                      label="หมายเหตุ"
                      :rules="nameRules"
                    ></v-textarea>
                  </v-card-text>

                  <v-col cols="12" class="pl-6">
                    <v-checkbox
                      required
                      :rules="rulesCheckBox"
                      v-model="checkbox"
                      label="ท่านยืนยันการขออนุมัติโอทีนี้ ระบบจะคำนวนข้อมูลการเข้าและออกงานของท่าน กรณี เปลี่ยน หรือไม่ถูกต้องรายการนี้อาจถูกยกเลิก"
                    ></v-checkbox>
                  </v-col>
                </v-form>

                <v-card-actions>
                  <!-- <v-spacer></v-spacer> -->
                  <v-col class="text-center pt-0 pb-10">
                    <v-btn
                      v-if="
                        (formRequest.ot_before_check_in_status &&
                          formRequest.request_ot_time_before) ||
                        (formRequest.ot_after_check_out_status &&
                          formRequest.request_ot_time_after)
                      "
                      :disabled="!valid_update"
                      color="success"
                      elevation="2"
                      dark
                      @click="sendRequestOT(formRequest, item_Info)"
                    >
                      ส่งขอโอที
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogFormHoliday" fullscreen>
              <v-toolbar color="indigo" dark>
                <v-toolbar-title>ขอโอทีวันหยุด</v-toolbar-title>
                <v-icon class="ml-2"> mdi-clock-alert-outline </v-icon>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  dark
                  @click="(dialogFormHoliday = false), clearData()"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #1b437c">
                          <th class="text-left">ข้อมูล</th>
                          <th class="text-left">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>วันที่</td>
                          <td>{{ item_Info.masShiftTypeNameDay }}</td>
                        </tr>
                        <tr>
                          <td>ประเภทกะ</td>
                          <td>{{ item_Info.shiftCode }}</td>
                        </tr>
                        <tr>
                          <td>กะเข้างาน</td>
                          <td>{{ item_Info.masShiftTypeStartTime }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเข้างาน</td>
                          <td>{{ item_Info.checkInDay }}</td>
                        </tr>
                        <tr>
                          <td>กะเลิกงาน</td>
                          <td>{{ item_Info.masShiftTypeEndTime }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเลิกงาน</td>
                          <td>{{ item_Info.checkOutDay }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>

                <v-divider style="background-color: #ffffff"></v-divider>

                <v-col>
                  <!-- <v-card-text cols="12">
                    <v-col cols="12" class="pa-0">
                      <v-checkbox
                        label="ขอโอทีทั้งวัน"
                        v-model="custom"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      class="pa-0"
                      v-if="
                        item_Info.lateStatus != 'สาย' &&
                        item_Info.leaveSummaryDayName != 'ครึ่งวันเช้า'
                      "
                    >
                      <v-checkbox
                        :disabled="custom"
                        label="ขอโอทีก่อนเวลาทำงาน"
                        v-model="formRequest.ot_before_check_in_status"
                      ></v-checkbox>
                      <v-select
                        :items="itemsTime"
                        v-model="formRequest.request_ot_time_before"
                        :disabled="!formRequest.ot_before_check_in_status"
                        clearable
                        clear-icon="mdi-close-circle"
                        outlined
                        dense
                        label="เวลา"
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      class="pa-0"
                      v-if="item_Info.leaveSummaryDayName != 'ครึ่งวันบ่าย'"
                    >
                      <v-checkbox
                        label="ขอโอทีหลังเวลาทำงาน"
                        :disabled="custom"
                        required
                        v-model="formRequest.ot_after_check_out_status"
                      ></v-checkbox>
                      <v-select
                        :items="itemsTime"
                        v-model="formRequest.request_ot_time_after"
                        clearable
                        clear-icon="mdi-close-circle"
                        :disabled="!formRequest.ot_after_check_out_status"
                        outlined
                        dense
                        label="เวลา"
                      ></v-select>
                    </v-col>
                  </v-card-text> -->

                  <v-form
                    ref="form_update"
                    v-model="valid_update"
                    lazy-validation
                  >
                    <v-card-text class="pb-0 mb-0">
                      <v-textarea
                        :disabled="
                          item_Info.checkInDay == 'วันหยุด' ||
                          item_Info.checkOutDay == 'วันหยุด'
                        "
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        v-model="formRequest.otRemark"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="หมายเหตุ"
                        :rules="nameRules"
                      ></v-textarea>
                    </v-card-text>

                    <v-row class="pl-6">
                      <v-col>
                        <v-checkbox
                          v-model="checkbox"
                          required
                          :rules="rulesCheckBox"
                          label='ท่านยืนยันการขออนุมัติโอทีนี้ ระบบจะคำนวนข้อมูลการเข้าและออกงานของท่าน กรณี เปลี่ยน หรือไม่ถูกต้องรายการนี้อาจถูกยกเลิก'
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-form>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="!valid_update"
                      color="success"
                      elevation="2"
                      dark
                      @click="sendRequestOTHoliday(formRequest, item_Info)"
                    >
                      ส่งขอโอที
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-card>
            </v-dialog>
            <!-- --------- {{profile}} ----------- -->

            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab id="list1" href="#list1" class="primary--text"
              v-if="profile.positionLevelOrderNumber == 1 || profile.positionLevelOrderNumber == 2"
                >
                รายการ
              </v-tab>
              <v-tab
                id="history"
                @click="getDataHistory()"
                v-if="profile.positionLevelOrderNumber == 1 || profile.positionLevelOrderNumber == 2"
                href="#history"
                class="primary--text"
              >
                ประวัติ
              </v-tab>
              <v-tab
                id="request"
                href="#request"
                v-if="profile.positionLevelOrderNumber != 1"
                class="primary--text"
                @click="getDataHeaderDraft()"
              >
                คำขอ
                <v-badge
                  v-if="dataICountItemHeaderDraft > 0"
                  color="red"
                  :content="dataICountItemHeaderDraft"
                >
                </v-badge>
              </v-tab>
               <v-tab
                id="Verify"
                href="#Verify"
                class="primary--text"
                v-if="profile.positionLevelOrderNumber != 1"
                @click="getDataHeaderConfirm()"
              >
                รับทราบ
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="list1">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือนที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปีที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getData()"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">วัน</th>
                        <th class="text-center">เวลาเข้างาน</th>
                        <th class="text-center">เวลาเลิกงาน</th>
                        <th class="text-center">AC</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(items, index) in shifttem" :key="index">
                        <td>
                          {{ items.shiftDay }}
                          <!-- {{ items.shiftCode }} -->
                        </td>
                        <td>
                            <v-chip
                              class="ma-2"
                              :color="items.colorin"
                              text-color="white"
                            >
                              {{ items.checkInStartStamp }}
                            </v-chip>
                        </td>
                        <td>
                            <v-chip
                              class="ma-2"
                              :color="items.colorout"
                              text-color="white"
                            >
                              {{ items.checkInEndStamp }}
                            </v-chip>
                        </td>
                        <td>
                          <div class="text-center" v-if="items.beforeCheckShiftCheckin">
                            <v-btn
                              v-if="
                                items.ot_status == 'approve'
                              "
                              color="success"
                              elevation="10"
                              dark
                            >
                              อนุมัติ
                            </v-btn>
                            <v-btn
                              v-if="
                                items.ot_status == 'cancel'
                              "
                              color="error"
                              elevation="10"
                              dark
                              @click="
                                (dialogForm = true),
                                  itemInfo(items),
                                  validate('UPDATE')
                              "
                            >
                              ไม่อนุมัติ
                            </v-btn>
                            <v-btn
                              v-if="
                                items.ot_status != 'approve' &&
                                items.ot_status != 'cancel' &&
                                !items.request_status &&
                                items.checkBeforeMonth &&
                                items.leaveSummaryDayName != 'เต็มวัน' &&
                                items.masShiftTypeHoliday != 'True'
                              "
                              color="primary"
                              elevation="10"
                              dark
                              @click="
                                (dialogForm = true),
                                  itemInfo(items),
                                  validate('UPDATE')
                              "
                            >
                              ขอโอที
                            </v-btn>
                            <v-btn
                              v-if="
                                items.ot_status != 'approve' &&
                                items.ot_status != 'cancel' &&
                                items.masShiftTypeHoliday === 'True' &&
                                !items.request_status &&
                                items.checkInStartStamp != 'วันหยุด' &&
                                items.checkBeforeMonth
                              "
                              color="primary"
                              dark
                              @click="
                                (dialogFormHoliday = true),
                                  itemInfo(items),
                                  validate('UPDATE')
                              "
                            >
                              ขอโอที {{items.shiftCode}}
                            </v-btn>
                            <v-btn
                              v-if="
                              items.ot_status != 'approve' &&
                              items.ot_status != 'cancel' &&
                                items.request_status &&
                                items.check_cant_request_status == 'true'
                              "
                              color="orange"
                              dark
                            >
                              ดำเนินการ
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="history">
                <!-- <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือนที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปีที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getSearchHistory()"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels> -->
                <v-card
                  elevation="2"
                  class="ma-5"
                  v-if="profile.positionLevelOrderNumber == 1 || profile.positionLevelOrderNumber == 2"
                >
                  <v-card>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ profile.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อพนักงาน</td>
                            <td>{{ profile.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันที่ขอ</td>
                            <td>{{ dataItemHistory.total_request }} วัน</td>
                          </tr>
                          <tr>
                            <td>รอหัวหน้าตรวจสอบ</td>
                            <td>{{ dataItemHistory.count_draft }} วัน</td>
                          </tr>
                          <tr>
                            <td>รอฝ่ายบุคคลตรวจสอบ</td>
                            <td>{{ dataItemHistory.count_confirm }} วัน</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันที่ยกเลิก</td>
                            <td>{{ dataItemHistory.count_cancel }} วัน</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันที่อนุมัติ</td>
                            <td>{{ dataItemHistory.count_approve }} วัน</td>
                          </tr>
                          <tr>
                            <td>รวมชั่วโมงโอทีที่ได้</td>
                            <td>
                              <v-list-item-title :class="` font-weight-bold green--text`">{{ dataItemHistory.sum_hours_approve }} </v-list-item-title>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-card>
                <v-card v-if="profile.positionLevelOrderNumber == 1 || profile.positionLevelOrderNumber == 2">
                  <v-col cols="12">
                    <br />
                    <v-card
                      elevation="10"
                      v-for="(items, index) in otRequestItem"
                      :key="index"
                      class="ma-2 pa-2"
                    >
                      <v-card-actions class="ma-0 pa-0">
                        <v-btn v-if="items.status == 'draft'" color="blue" text>
                          หัวหน้าตรวจสอบ
                        </v-btn>

                        <v-btn
                          v-if="items.status == 'confirm'"
                          color="orange"
                          text
                        >
                          ฝ่ายบุคคลตรวจสอบ
                        </v-btn>

                        <v-btn
                          v-if="items.status == 'approve'"
                          color="green"
                          text
                        >
                          อนุมัติ
                        </v-btn>

                        <v-btn
                          v-if="items.status == 'cancel'"
                          color="red"
                          text
                        >
                          รายการถูกยกเลิก
                        </v-btn>
                      </v-card-actions>
                      <v-row>
                        <v-col cols="2" class="pa-2 ml-5 mt-5">
                          <v-img
                            v-if="items.status != 'approve'"
                            :src="require('@/assets/otImg1.png')"
                          ></v-img>
                          <v-img
                            v-if="items.status == 'approve'"
                            :src="require('@/assets/OTimg.png')"
                          ></v-img>
                        </v-col>
                        <v-col class="ml-0 mb-0 pa-0">
                          <!-- ท้ังวัน -->
                          <v-card-text
                            class="text-left"
                            v-if="
                              items.ot_before_check_in_status === 'True' &&
                              items.ot_after_check_out_status === 'True'
                            "
                          >
                            <strong
                              >วันที่: {{ items.ot_day }} -{{ items.ot_month }}-
                              {{ items.ot_year }}</strong
                            >
                            <br />
                            เวลาเช้า: {{ items.check_in }} -
                            {{ items.shift_check_in }}
                            <v-chip
                              v-if="items.ot_time_before_calculate == '00:00'"
                              class="text-right ml-10"
                              color="red"
                              small
                            >
                              {{ items.ot_time_before_calculate }}
                            </v-chip>
                            <v-chip
                              v-if="
                                items.ot_time_before_calculate != '00:00' &&
                                items.ot_time_before_calculate != null
                              "
                              class="text-right ml-10"
                              color="teal lighten-2"
                              small
                            >
                              {{ items.ot_time_before_calculate }}
                            </v-chip>
                            <br />
                            เวลาเย็น: {{ items.shift_check_out }} -
                            {{ items.check_out }}
                            <v-chip
                              v-if="
                                items.ot_time_after_calculate != '00:00' &&
                                items.ot_time_after_calculate != null
                              "
                              class="text-right ml-10"
                              color="teal lighten-2"
                              small
                            >
                              {{ items.ot_time_after_calculate }}
                            </v-chip>
                            <v-chip
                              v-if="items.ot_time_after_calculate == null"
                              class="text-right ml-10"
                              color="teal lighten-2"
                              small
                            >
                              00:00
                            </v-chip>
                            <v-chip
                              v-if="items.ot_time_after_calculate == '00:00'"
                              class="text-right ml-10"
                              color="red"
                              small
                            >
                              {{ items.ot_time_after_calculate }} </v-chip
                            ><br />
                          </v-card-text>
                          <!-- บ่าย -->
                          <v-card-text
                            class="text-left"
                            v-if="
                              items.ot_before_check_in_status === 'False' &&
                              items.ot_after_check_out_status === 'True'
                            "
                          >
                            <strong
                              >วันที่: {{ items.ot_day }} -{{ items.ot_month }}-
                              {{ items.ot_year }}</strong
                            >
                            <br />
                            เวลาเย็น: {{ items.shift_check_out }} -
                            {{ items.check_out }}
                            <v-chip
                              v-if="
                                items.ot_time_after_calculate != '00:00' &&
                                items.ot_time_after_calculate != null
                              "
                              class="text-right ml-10"
                              color="teal lighten-2"
                              small
                            >
                              {{ items.ot_time_after_calculate }}
                            </v-chip>
                            <v-chip
                              v-if="
                                items.ot_time_after_calculate == '00:00' &&
                                items.ot_time_after_calculate != null
                              "
                              class="text-right ml-10"
                              color="red"
                              small
                            >
                              {{ items.ot_time_after_calculate }}
                            </v-chip>
                            <v-chip
                              v-if="items.ot_time_after_calculate == null"
                              class="text-right ml-10"
                              small
                            >
                              00:00 </v-chip
                            ><br />
                          </v-card-text>
                          <!-- เช้า -->
                          <v-card-text
                            class="text-left"
                            v-if="
                              items.ot_before_check_in_status === 'True' &&
                              items.ot_after_check_out_status === 'False'
                            "
                          >
                            <strong
                              >วันที่: {{ items.ot_day }} -{{ items.ot_month }}-
                              {{ items.ot_year }}</strong
                            >
                            <br />
                            เวลาเช้า: {{ items.check_in }} -
                            {{ items.shift_check_in }}
                            <v-chip
                              class="text-right ml-10"
                              color="teal lighten-2"
                              small
                            >
                              {{ items.ot_time_before_calculate }}
                            </v-chip>
                            <br />
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-card>
              </v-tab-item>
              <v-tab-item value="request">
                <v-tabs v-model="tabsHeaer" fixed-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    id="request_waiting"
                    href="#request_waiting"
                    @click="getDataHeaderDraft()"
                  >
                    <v-icon>mdi-clock</v-icon>รออนุมัติ
                  </v-tab>
                  <v-tab
                    id="approve_history"
                    href="#approve_history"
                    @click="getDataHeaderConfirm()"
                  >
                    <v-icon>mdi-file-document</v-icon>ประวัติ
                  </v-tab>
                </v-tabs>
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือนที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปีที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-text-field
                            label="ชื่อพนักงาน"
                            v-model="employeeName"
                            clearable
                            clear-icon="mdi-close-circle"
                            outlined
                            counter="100"
                            maxlength="30"
                            required
                          ></v-text-field>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getData()"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-tabs-items v-model="tabsHeaer">
                  <v-tab-item value="request_waiting">
                    <v-toolbar dark color="#1b437c">
                      <div>รายละเอียด</div>
                    </v-toolbar>
                    <v-col
                      cols="12"
                      v-for="(itemsTeam, indexTeam) in dataItemDraft"
                      :key="indexTeam"
                    >
                      <v-card
                        v-if="itemsTeam.total_draft"
                        elevation="10"
                        rounded="xl"
                      >
                        <v-card
                          color="red"
                          max-height="10"
                          class="pa-3 text-right"
                          dark
                          rounded="t-xl"
                        >
                        </v-card>

                          <v-col class="pb-0">
                            <v-card-text class="text-left">
                              <h5 :class="` font-weight-bold indigo--text`">
                                {{ itemsTeam.empCode }}
                              </h5>
                              <h5 :class="` font-weight-light purple--text`">
                                {{ itemsTeam.empFull_NameTH }}
                              </h5>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="#B61C1C"
                                    >mdi-send-clock</v-icon
                                  >
                                </v-list-item-icon>
                                <v-list-item-title
                                  >วันที่ขอทั้งหมด</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  ><strong
                                    >{{ itemsTeam.count_total }} วัน
                                  </strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="#B61C1C">mdi-web-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title
                                  >รวมโอทีทั้งหมด</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  v-if="itemsTeam.sum_hours_draft != null"
                                  ><strong>{{
                                    itemsTeam.sum_hours_draft
                                  }}</strong></v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  v-if="itemsTeam.sum_hours_draft == null"
                                  ><strong>0</strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="#B61C1C"
                                    >mdi-clock-alert</v-icon
                                  >
                                </v-list-item-icon>
                                <v-list-item-title
                                  >หัวหน้าตรวจสอบ</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  ><strong
                                    >{{ itemsTeam.total_draft }} วัน</strong
                                  ></v-list-item-title
                                >
                              </v-list-item>
                            </v-card-text>
                          </v-col>
                        <v-card-actions>
                          <v-btn
                            block
                            rounded
                            class="white--text"
                            color="orange"
                            @click="getInfo(itemsTeam)"
                          >
                            ตรวจสอบรายการคำขอโอที
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-tab-item>
                  <v-tab-item value="approve_history">
                    <v-toolbar dark color="#1b437c">
                      <div>รายละเอียด</div>
                    </v-toolbar>
                    <v-col
                      cols="12"
                      v-for="(itemsTeam, indexTeam) in dataItemConfirm"
                      :key="indexTeam"
                    >
                    <v-card
                        elevation="10"
                        rounded="xl"
                      >
                        <v-card
                          color="#1A237E"
                          max-height="10"
                          class="pa-3 text-right"
                          dark
                          rounded="t-xl"
                        >
                        </v-card>
                        <v-col class="pb-0">
                            <v-card-text class="text-left">
                              <h5 :class="` font-weight-bold indigo--text`">
                                {{ itemsTeam.empCode }}
                              </h5>
                              <h5 :class="` font-weight-light purple--text`">
                                {{ itemsTeam.empFull_NameTH }}
                              </h5>
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-send-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title
                                  >วันที่ขอทั้งหมด</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  ><strong
                                    >{{ itemsTeam.count_total }} วัน
                                  </strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-web-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title
                                  >รวมโอทีที่ได้</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  v-if="itemsTeam.sum_hours_approve != null"
                                  ><strong>{{
                                    itemsTeam.sum_hours_approve
                                  }}</strong></v-list-item-title
                                >
                                <v-list-item-title
                                  v-if="itemsTeam.sum_hours_approve == null"
                                  ><strong>0</strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >หัวหน้าตรวจสอบ</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_draft }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >ฝ่ายบุคคลตรวจสอบ</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_confirm }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >อนุมัติแล้ว</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_approve }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                            </v-card-text>
                          </v-col>
                       </v-card>
                    </v-col>
                  </v-tab-item>
                </v-tabs-items>

                <v-dialog
                  v-model="dialogView"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <v-app-bar fixed app color="deep-purple accent-4" dark>
                    <v-btn icon dark @click="getData() , dialogView = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title> รายการ
                      {{ profileView.empFullName }}
                    </v-toolbar-title>
                  </v-app-bar>

                  <v-card>
                    <v-col cols="12">
                      <br />
                      <br />
                      <br />
                      <v-alert
                        v-if="otRequestItem.length == 0 && !loading"
                        cols="6"
                        elevation="12"
                        dense
                        outlined
                        type="warning"
                      >
                        คำเตือน<br /> ไม่พบข้อมูลการขออนุมัติโอที
                      </v-alert>
                      <v-progress-circular
                        v-if="loading"
                        :size="50"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                      <v-card
                        elevation="10"
                        v-for="(items, index) in otRequestItem"
                        :key="index"
                        class="ma-2 pa-2"
                      >
                        <v-card
                        >
                          <v-card-actions cols="6" class="ma-0 pa-0">
                            <v-btn
                              v-if="items.status == 'draft'"
                              color="blue"
                              text
                            >
                              หัวหน้าตรวจสอบ
                            </v-btn>

                            <v-btn
                              v-if="items.status == 'confirm'"
                              color="orange"
                              text
                            >
                              ฝ่ายบุคคลตรวจสอบ
                            </v-btn>

                            <v-btn
                              v-if="items.status == 'approve'"
                              color="green"
                              text
                            >
                              อนุมัติ
                            </v-btn>
                            <v-btn
                              v-if="items.status == 'cancel'"
                              color="red"
                              text
                            >
                              รายการถูกยกเลิก
                            </v-btn>
                          </v-card-actions>
                          <v-row>
                            <!-- {{items}} -->
                            <v-col cols="3" class="text-center pa-5 ml-3">
                              <v-col>
                              <v-sheet class="text-center"
                                color="white"
                                height="60"
                                elevation="5"
                                rounded="t-xl"
                                width="50"
                              >
                              <v-sheet class="text-center"
                                color="red"
                                height="20"
                                rounded="t-xl"
                                width="50"
                              >
                              </v-sheet>
                                  <h4>{{ items.ot_day }}</h4>
                              </v-sheet>
                              </v-col>
                            </v-col>
                            <v-col class="ml-0 mb-0 pa-0">
                              <!-- เช้าเย็น -->
                              <v-card-text
                                class="text-left"
                                v-if="
                                  items.ot_before_check_in_status === 'True' &&
                                  items.ot_after_check_out_status === 'True'
                                "
                              >
                                เวลาเช้า: {{ items.shift_check_in }} - {{ items.check_in }}<br>
                                โอทีก่อนเข้างาน:
                                <v-chip
                                  v-if="
                                    items.ot_time_before_calculate != '00:00' &&
                                    items.ot_time_before_calculate != null
                                  "
                                  class="text-right ml-2"
                                  color="teal lighten-2"
                                  small
                                >
                                  {{ items.ot_time_before_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="
                                    items.ot_time_before_calculate == '00:00' &&
                                    items.ot_time_before_calculate != null
                                  "
                                  class="text-right ml-10"
                                  color="red"
                                  small
                                >
                                  {{ items.ot_time_before_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="items.ot_time_before_calculate == null"
                                  class="text-right ml-10"
                                  small
                                >
                                  00:00
                                </v-chip>
                                <br />
                                เวลาเย็น: {{ items.shift_check_out }} -
                                {{ items.check_out }}<br>
                                โอทีหลังเลิกงาน:
                                <v-chip
                                  v-if="
                                    items.ot_time_after_calculate != '00:00' &&
                                    items.ot_time_after_calculate != null
                                  "
                                  class="text-right ml-2"
                                  color="teal lighten-2"
                                  small
                                >
                                  {{ items.ot_time_after_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="
                                    items.ot_time_after_calculate == '00:00' &&
                                    items.ot_time_after_calculate != null
                                  "
                                  class="text-right ml-10"
                                  color="red"
                                  small
                                >
                                  {{ items.ot_time_after_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="items.ot_time_after_calculate == null"
                                  class="text-right ml-10"
                                  small
                                >
                                  00:00
                                </v-chip>
                                <br />
                                หมายเหตุ: {{items.otRemark}}
                              </v-card-text>

                              <!-- เย็น -->

                              <v-card-text
                                class="text-left pt-9"
                                v-if="
                                  items.ot_before_check_in_status === 'False' &&
                                  items.ot_after_check_out_status === 'True'
                                "
                              >
                                เวลาเย็น: {{ items.shift_check_out }} -
                                {{ items.check_out }}<br>
                                โอทีหลังเลิกงาน:
                                <v-chip
                                  v-if="items.ot_time_before_calculate != null"
                                  class="text-right ml-2"
                                  color="teal lighten-2"
                                  small
                                >
                                  {{ items.ot_time_after_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="items.ot_time_before_calculate == null"
                                  class="text-right ml-10"
                                  color="teal lighten-2"
                                  small
                                >
                                  00:00</v-chip
                                ><br />
                                 หมายเหตุ: {{items.otRemark}}
                              </v-card-text>

                              <!-- เช้า -->

                              <v-card-text
                                class="text-left pt-9"
                                v-if="
                                  items.ot_before_check_in_status === 'True' &&
                                  items.ot_after_check_out_status === 'False'
                                "
                              >
                                เวลาเช้า: {{ items.check_in }} -
                                {{ items.shift_check_in }}<br>
                                โอทีก่อนเข้างาน:
                                <v-chip
                                  v-if="items.ot_time_before_calculate != null"
                                  class="text-right ml-2"
                                  color="teal lighten-2"
                                  small
                                >
                                  {{ items.ot_time_before_calculate }}
                                </v-chip>
                                <v-chip
                                  v-if="items.ot_time_before_calculate == null"
                                  class="text-right ml-10"
                                  color="teal lighten-2"
                                  small
                                >
                                  00:00
                                </v-chip>
                                <br />
                                 หมายเหตุ: {{items.otRemark}}
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-card-actions>
                            <v-btn
                              small
                              v-if="items.status == 'draft'"
                              color="teal accent-4"
                              @click="
                                  itemInfo(items),
                                  (dialogEditOT = true)
                              "
                              dark
                            >
                              แก้ไข
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              v-if="items.status == 'draft'"
                              color="red"
                              dark
                              @click="getDataReject(items)"
                            >
                              ไม่อนุมัติ
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-card>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-alert
                        cols="6"
                        elevation="12"
                        dense
                        outlined
                        type="warning"
                      >
                        คำเตือน<br />ไม่สามารถอนุมัติคำขอล่วงหน้าได้<br />เป็นการอนุมัติย้อนหลังเท่านั้น
                      </v-alert>
                    </v-col> -->
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                      v-if="otRequestItem.length > 0"
                        block
                        elevation="2"
                        depressed
                        color="success"
                        @click="updateStatusConfirm(otRequestItem)"
                      >
                        ตรวจสอบ เรียบร้อย
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <v-dialog v-model="dialogReject">
                    <v-card>
                      <v-card-title class="text-h6 grey lighten-2">
                        <span class="headline">หมายเหตุ ยกเลิก</span>
                        <v-col class="text-right pb-0 pt-0 pr-0">
                          <v-icon color="#173053" @click="dialogReject = false"
                            >mdi-close-circle</v-icon
                          >
                        </v-col>
                      </v-card-title>
                      <v-card-text class="pa-4 pb-0">
                        <v-textarea
                          v-model="formUpdate.otDetail"
                          maxlength="100"
                          rows="3"
                          row-height="25"
                          outlined
                          :rules="nameRules"
                          clearable
                          clear-icon="mdi-close-circle"
                          label="หมายเหตุ"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions class="pa-2 ma-2 mt-0">
                        <v-spacer></v-spacer>
                        <v-btn
                          dark
                          color="red"
                          elevation="2"
                          @click="updateStatusCancel(formUpdate)"
                        >
                          ไม่อนุมัติ
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="dialogEditOT" fullscreen>
                    <v-toolbar color="indigo" dark>
                      <v-toolbar-title>ตรวจสอบการขอโอที</v-toolbar-title>

                      <v-icon class="ml-2"> mdi-clock-alert-outline </v-icon>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        dark
                        @click="getInfo(item_Info), dialogEditOT = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>

                    <v-card>
                      <v-card>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background-color: #1b437c">
                                <th class="text-left">ข้อมูล</th>
                                <th class="text-left">รายละเอียด</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>วันที่</td>
                                <td>{{ item_Info.otDateName }}</td>
                              </tr>
                              <tr>
                                <td>ประเภทกะ</td>
                                <td>{{ item_Info.shiftCode }}</td>
                              </tr>
                              <tr>
                                <td>กะเข้างาน</td>
                                <td>{{ item_Info.shift_check_in }}</td>
                              </tr>
                              <tr>
                                <td>เวลาเข้างาน</td>
                                <td>{{ item_Info.check_in }}</td>
                              </tr>
                              <tr>
                                <td>กะเลิกงาน</td>
                                <td>{{ item_Info.shift_check_out }}</td>
                              </tr>
                              <tr>
                                <td>เวลาเลิกงาน</td>
                                <td>{{ item_Info.check_out }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card>

                      <v-divider style="background-color: #ffffff"></v-divider>

                      <v-col class="pa-2">
                        <v-card-text class="pa-0">
                          <v-col

                          >
                            <v-col cols="12" class="pa-0">
                              <!-- {{item_Info.ot_before_check_in_status}} -->
                              <v-checkbox
                                label="ขอโอทีก่อนเวลาทำงาน"
                                v-model="item_Info.ot_before_check_in_status"
                              ></v-checkbox>
                            </v-col>
                            <v-row>
                              <v-col cols="6" class="pa-2">
                                <v-select
                                  :items="itemsTimeHoliday"
                                  v-model="item_Info.request_ot_time_before"
                                  outlined
                                  readonly
                                  dense
                                  label="จำนวนเวลาโอทีที่ขอ"
                                ></v-select>
                              </v-col>
                              <v-col cols="6" class="pa-2">
                                <v-select
                                  :items="itemsTimeHoliday"
                                  v-model="item_Info.ot_time_before_calculate"
                                  outlined
                                  dense
                                  label="จำนวนเวลาโอทีที่ให้"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col

                          >
                            <v-col cols="12" class="pa-0">
                              <!-- {{item_Info.ot_after_check_out_status}} -->
                              <v-checkbox
                                label="ขอโอทีหลังเวลาทำงาน"
                                v-model="item_Info.ot_after_check_out_status"
                              ></v-checkbox>
                            </v-col>
                            <v-row>
                              <v-col cols="6" class="pa-2">
                                <v-select
                                  :items="itemsTimeHoliday"
                                  v-model="item_Info.request_ot_time_after"
                                  outlined
                                  readonly
                                  dense
                                  label="จำนวนเวลาโอทีที่ขอ"
                                ></v-select>
                              </v-col>
                              <v-col cols="6" class="pa-2">
                                <v-select
                                  :items="itemsTimeHoliday"
                                  v-model="item_Info.ot_time_after_calculate"
                                  outlined
                                  dense
                                  label="จำนวนเวลาโอทีที่ให้"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-card-text>

                        <v-card-text class="pb-0 mb-0">
                          <v-form
                            ref="form_update"
                            v-model="valid_update"
                            lazy-validation
                          >
                            <v-textarea
                              maxlength="100"
                              rows="3"
                              row-height="25"
                              outlined
                              v-model="item_Info.otRemark"
                              clearable
                              clear-icon="mdi-close-circle"
                              label="หมายเหตุ"
                              :rules="nameRules"
                            ></v-textarea>
                          </v-form>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :disabled="!valid_update"
                            color="success"
                            elevation="2"
                            dark
                            @click="editRequestOT(item_Info)"
                          >
                            แก้ไขการขอโอที
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-card>
                  </v-dialog>
                </v-dialog>
              </v-tab-item>
              <v-tab-item value="Verify">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือนที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปีที่สร้างข้อมูล"
                            class="ma-2"
                          ></v-select>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getDataHeaderConfirm()"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                    <v-toolbar dark color="#1b437c">
                      <div>รายละเอียด</div>
                    </v-toolbar>
                    <v-col
                      cols="12"
                      v-for="(itemsTeam, indexTeam) in dataItemConfirm"
                      :key="indexTeam"
                    >
                    <v-card
                        elevation="10"
                        rounded="xl"
                      >
                        <v-card
                          color="#1A237E"
                          max-height="10"
                          class="pa-3 text-right"
                          dark
                          rounded="t-xl"
                        >
                        </v-card>
                        <v-col class="pb-0">
                            <v-card-text class="text-left">
                              <h5 :class="` font-weight-bold indigo--text`">
                                {{ itemsTeam.empCode }}
                              </h5>
                              <h5 :class="` font-weight-light purple--text`">
                                {{ itemsTeam.empFull_NameTH }}
                              </h5>
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-send-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title
                                  >วันที่ขอทั้งหมด</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  ><strong
                                    >{{ itemsTeam.count_total }} วัน
                                  </strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-web-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title
                                  >รวมโอทีที่ได้</v-list-item-title
                                >
                                <v-list-item-title class="text-right"
                                  v-if="itemsTeam.sum_hours_approve != null"
                                  ><strong>{{
                                    itemsTeam.sum_hours_approve
                                  }}</strong></v-list-item-title
                                >
                                <v-list-item-title
                                  v-if="itemsTeam.sum_hours_approve == null"
                                  ><strong>0</strong></v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >หัวหน้าตรวจสอบ</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_draft }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >ฝ่ายบุคคลตรวจสอบ</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_confirm }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="pa-0 ma-0">
                                <v-list-item-icon>
                                  <v-icon color="indigo">mdi-clock-alert</v-icon>
                                </v-list-item-icon>
                                <v-list-item-subtitle
                                  >อนุมัติแล้ว</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-right"
                                 >
                                 <strong>{{ itemsTeam.total_approve }} วัน</strong>
                                 </v-list-item-title
                                >
                              </v-list-item>
                            </v-card-text>
                          </v-col>
                       </v-card>
                    </v-col>

              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
export default {
  name: 'Info',
  data () {
    return {
      profileView: [],
      empProfile: [],
      shifttem: [],
      otRequestItem: [],
      dataReportMonth: [],
      dataItemHistory: [],
      year: '',
      month: '',
      day: '',
      loading: false,
      currentEndTime: '',
      dataItemRequest: [],
      dataItemConfirm: [],
      dataItemDraft: [],
      dataItemVerify: [],
      dialogForm: false,
      dialogFormHoliday: false,
      dialogView: false,
      dialogReject: false,
      dialogEditOT: false,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'tabInfo',
      dataICountItemHeaderDraft: 0,
      itemPanel: 1,
      panel: [],
      tabsHeaer: 'request',
      employeeName: '',
      custom: true,
      checkbox: false,
      currentMonth: '',
      nameRules: [(v) => !!v || 'กรุณากรอก หมายเหตุ ที่ขอโอที'],
      rulesCheckBox: [(v) => !!v || ' '],
      valid_update: true,
      item_Info: [],
      formUpdate: [],
      formRequest: {
        ot_before_check_in_status: false,
        request_ot_time_before: '00:00',
        ot_after_check_out_status: false,
        request_ot_time_after: '00:00',
        otRemark: ''
      },
      empCode: '',
      status: '',
      ot_time: '',
      itemsTime: [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00'
      ],
      itemsTimeHoliday: [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00'
      ]
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    validate (Action) {
      switch (Action) {
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      this.dataReady = true
      if (this.profile.positionLevelOrderNumber < 3) {
        await this.ot_requests(this.profile.empCode) //
        await this.shift_import() //
      }
      if (this.profile.positionLevelOrderNumber > 1) {
        await this.getDataHeaderRequest()
        await this.getDataHeaderDraft()
        await this.getDataHeaderConfirm()
      }

      this.dataReady = false
    },
    async editRequestOT (item) {
      this.dataReady = false
      let dt = {
        ot_time_after_calculate: item.ot_time_after_calculate,
        ot_time_before_calculate: item.ot_time_before_calculate,
        ot_after_check_out_status: item.ot_after_check_out_status,
        ot_before_check_in_status: item.ot_before_check_in_status,
        otRemark: item.otRemark,
        LAST_USER: this.profile.userName
      }
      let formLog = {
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        empCode: this.profile.empCode,
        shiftCode: item.shiftCode,
        ot_before_check_in_status: item.ot_before_check_in_status,
        ot_after_check_out_status: item.ot_after_check_out_status,
        shift_check_in: item.shift_check_in,
        check_in: item.check_in,
        before_check_in_minute: item.before_check_in_minute,
        shift_check_out: item.shift_check_out,
        check_out: item.check_out,
        after_check_out_minute: item.after_check_out_minute,
        ot_year: item.ot_year,
        ot_month: item.ot_month,
        ot_day: item.ot_day,
        ot_date: item.ot_date,
        status: 'confirm',
        otRemark: item.otRemark,
        request_ot_time_after: item.request_ot_time_after,
        request_ot_time_before: item.request_ot_time_before,
        ot_time_after_calculate: item.ot_time_after_calculate,
        ot_time_before_calculate: item.ot_time_before_calculate,
        otDetail: item.otDetail,
        ot_request_late: 'edit_by_mgr'
      }
      this.$swal({
        title: 'ต้องการ ยืนยันการแก้ไขข้อมูลโอทีทั้งหมด ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/ot_request/edit_ot/" + item.otID,
            dt,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + '/ot_request/add_log',
            formLog
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'แก้ไขข้อมูลเรียบร้อย', 'success')
            this.dialogEditOT = false
            this.ot_requests(item.empCode)
            this.dataReady = false
          })
      })
    },
    async updateStatusCancel (formUpdate) {
      this.$swal({
        title: 'ท่านต้องการ ไม่อนุมัติการขอโอที ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        this.dataReady = true
        var ID = formUpdate.otID
        let ds = {
          status: 'cancel',
          otDetail: formUpdate.otDetail,
          LAST_UPDATE_MGR: moment().format('YYYY-MM-DD'),
          LAST_USER: this.profile.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/ot_request/edit/" + ID,
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ยกเลิกข้อมูลเรียบร้อย', 'success')
            // this.dialogView = false
            this.dataReady = true
            this.dialogReject = false
            this.ot_requests(formUpdate.empCode)
            this.dataReady = false
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = false
            console.log(error)
          })
      })
    },
    async updateStatusConfirm (item) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการยืนคำขอโอทีใช่หรือไม่',
        text: 'หากยืนยันรายการนี้จะส่งตรวจสอบฝ่ายบุคคล',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let dt = {
          empCode: item[0].empCode,
          ot_year: item[0].ot_year,
          ot_month: item[0].ot_month,
          ot_date: item[0].ot_date,
          LAST_UPDATE_MGR: moment().format('YYYY-MM-DD'),
          LAST_USER: this.profile.userName
        }
        console.log('DT', dt)
        axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/ot_request/updateHeaderApprove",
            dt,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
            this.dataReady = true
            this.ot_requests(dt.empCode)
            this.dataReady = false
          })
      })
    },
    clearData () {
      this.dialogEditOT = false
      this.ot_requests(this.profile.empCode)
    },
    clearDataAdd () {
      this.dataReady = true
      this.formRequest.request_ot_time_before = '00:00'
      this.formRequest.request_ot_time_after = '00:00'
      this.formRequest.ot_before_check_in_status = false
      this.formRequest.ot_after_check_out_status = false
      this.formRequest.otRemark = null
      this.checkbox = false
      this.dataReady = false
    },
    async itemInfo (item) {
      this.item_Info = item
      //  {{item_Info.ot_before_check_in_status}}
      //                         {{item_Info.ot_after_check_out_status}}
      this.item_Info.ot_before_check_in_status = item.ot_before_check_in_status === 'True'
      this.item_Info.ot_after_check_out_status = item.ot_after_check_out_status === 'True'
      this.item_Info.masShiftTypeNameDay =
        item.shiftDay + ' ' + this.month + ' ' + this.year
      this.item_Info.otDateName =
        item.ot_day + ' ' + this.month + ' ' + this.year
      this.item_Info.masShiftTypeMonth = this.month
      // 'DAY: ' + item.shiftDay + ' [' + item.masShiftTypeName + ']'
      this.item_Info.checkInDay = item.checkInStartStamp
      this.item_Info.checkOutDay = item.checkInEndStamp
      this.item_Info.ot_date = item.shiftYear + '-' + ('00' + item.shiftMonth).slice(-2) + '-' + ('00' + item.shiftDay).slice(-2)
      console.log('this.item_info', this.item_Info)
    },
    async sendRequestOT (dt, item) {
      if (dt.ot_before_check_in_status === false) {
        dt.request_ot_time_before = '00:00'
      }
      if (dt.ot_after_check_out_status === false) {
        dt.request_ot_time_after = '00:00'
      }

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ขอโอที ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let form = {
          CREATE_USER: this.profile.userName,
          LAST_USER: this.profile.userName,
          empCode: this.profile.empCode,
          shiftCode: item.shiftCode,
          ot_before_check_in_status: dt.ot_before_check_in_status,
          ot_after_check_out_status: dt.ot_after_check_out_status,
          shift_check_in: item.masShiftTypeStartTime,
          check_in: item.checkInStamp,
          shift_check_out: item.masShiftTypeEndTime,
          check_out: item.checkOutStamp,
          ot_year: item.shiftYear,
          ot_month: item.shiftMonth,
          ot_day: item.shiftDay,
          ot_date: item.ot_date,
          status: 'draft',
          otRemark: dt.otRemark,
          request_ot_time_after: dt.request_ot_time_after,
          request_ot_time_before: dt.request_ot_time_before
        }
        var endpoint = '/ot_request/add'
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + endpoint,
            form
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
            this.dialogForm = false
            this.getData()
            this.clearDataAdd()
          })
      })
    },
    async sendRequestOTHoliday (dt, item) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ขอโอที ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let form = {
          CREATE_USER: this.profile.userName,
          LAST_USER: this.profile.userName,
          empCode: this.profile.empCode,
          shiftCode: item.shiftCode,
          ot_before_check_in_status: 'True',
          ot_after_check_out_status: 'True',
          shift_check_in: '08:00',
          check_in: item.checkInStartStamp,
          shift_check_out: '17:00',
          check_out: item.checkInEndStamp,
          ot_year: item.shiftYear,
          ot_month: item.shiftMonth,
          ot_day: item.shiftDay,
          ot_date: item.shiftDate,
          status: 'draft',
          otRemark: dt.otRemark,
          request_ot_time_after: '04:00',
          request_ot_time_before: '04:00'
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/ot_request/addHoliday",
            form
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
            this.dialogFormHoliday = false
            this.getData()
            this.clearDataAdd()
          })
      })
    },
    async getDataHistory () {
      this.dataItemHistory = []

      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''
      var url =
        '/ot_request/get_history?empCode=' +
        this.profile.empCode +
        '&ot_year=' +
        this.year +
        monthSearch

      var dataItemHistory = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
      if (dataItemHistory.data) {
        // this.dataItemHistory.count_approve = 0
        this.dataItemHistory = dataItemHistory.data
        this.dataItemHistory.count_approve = (dataItemHistory.data.count_approve !== null) ? dataItemHistory.data.count_approve : 0
        this.dataItemHistory.count_cancel = (dataItemHistory.data.count_cancel !== null) ? dataItemHistory.data.count_cancel : 0
        this.dataItemHistory.count_confirm = (dataItemHistory.data.count_confirm !== null) ? dataItemHistory.data.count_confirm : 0
        this.dataItemHistory.count_draft = (dataItemHistory.data.count_draft !== null) ? dataItemHistory.data.count_draft : 0
        this.dataItemHistory.sum_hours_approve = (dataItemHistory.data.sum_hours_approve !== null) ? dataItemHistory.data.sum_hours_approve : 0
        this.dataItemHistory.sum_minutes_approve = (dataItemHistory.data.sum_minutes_approve !== null) ? dataItemHistory.data.sum_minutes_approve : 0
        this.dataItemHistory.total_request = (dataItemHistory.data.total_request !== null) ? dataItemHistory.data.total_request : 0
      }
    },
    async getDataHeaderRequest () {
      this.dataItemRequest = []

      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null
      this.employeeName = this.employeeName ? this.employeeName : null

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''

      var dataItemRequest = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/getEmpByHeader_liff?empCodeApprove=' +
            this.profile.empCode +
            monthSearch +
            '&ot_year=' +
            this.year +
            Company +
            Branch +
            Department +
            employeeName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      this.dataReady = false
      if (dataItemRequest.data) {
        var rs = dataItemRequest.data.map((item) => {
          if (item.status === 'draft' && typeof item !== 'undefined') {
            return item
          }
        })
        var data = rs.filter(function (element) {
          return element !== undefined
        })
        this.dataItemRequest = dataItemRequest.data
        if (data.length > 0) {
          this.tabsHeaer = 'request_waiting'
        }
      }
    },
    async getDataHeaderDraft () {
      this.dataItemDraft = []
      this.dataICountItemHeaderDraft = 0

      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null
      this.employeeName = this.employeeName ? this.employeeName : null

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''
      var Department =
       this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''

      var dataItemDraft = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/getEmpByHeader_draft_liff?empCodeApprove=' +
            this.profile.empCode +
            monthSearch +
            '&ot_year=' +
            this.year +
            Company +
            Branch +
            Department +
            employeeName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
      if (dataItemDraft.data) {
        this.dataReady = false

        var rs = dataItemDraft.data.map((item) => {
          if (item.total_draft > 0) {
            return item
          }
        })

        var data = rs.filter(function (element) {
          return element !== undefined
        })

        this.dataICountItemHeaderDraft = data.length
        this.dataItemDraft = dataItemDraft.data

        if (data.length > 0) {
          this.tabs = 'request'
        }
      }
    },
    async getDataHeaderConfirm () {
      this.dataItemConfirm = []

      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null
      this.employeeName = this.employeeName ? this.employeeName : null

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''

      var dataItemConfirm = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ot_request/getEmpByHeader_confirm_liff?empCodeApprove=' +
            this.profile.empCode +
            monthSearch +
            '&ot_year=' +
            this.year +
            Company +
            Branch +
            Department +
            employeeName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )

      if (dataItemConfirm.data) {
        this.dataItemConfirm = dataItemConfirm.data
      }
    },
    async getDataHeaderVerify () {
      this.dataItemVerify = []

      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var monthSearch =
        this.month !== null
          ? '&ot_month=' + this.getMonthThToINT(this.month)
          : ''

      var url =
        '/ot_request/getEmpByHeader_Verify?empCodeVerify=' +
            this.profile.empCode +
            monthSearch +
            '&ot_year=' +
            this.year

      var dataItemVerify = await axios.get(this.DNS_IP + url)

      if (dataItemVerify.data) {
        this.dataItemVerify = dataItemVerify.data
      }
    },
    getDataReject (item) {
      this.formUpdate = []
      this.dialogReject = true
      this.formUpdate = item
      this.formUpdate.otDetail = '-'
    },
    async getInfo (item) {
      this.dataReady = true
      this.profileView = item
      this.dialogView = true
      this.profileView.empFullName = item.empFull_NameTH
      await this.ot_requests(this.profileView.empCode)
      this.dataReady = false
    },
    async ot_requests (empCode) {
      this.loading = true
      this.otRequestItem = []
      var dataEmpCode = (!empCode || typeof empCode !== 'undefined') ? empCode : this.profile.empCode

      var monthSearch =
        this.month !== ''
          ? this.getMonthThToINT(this.month)
          : moment().format('MM')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      var url =
        '/ot_request/getEmpCodeOtMonth?empCode=' +
       dataEmpCode +
        '&ot_month=' +
        monthSearch +
        '&ot_year=' +
        this.year

      var otRequestItem = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
      if (otRequestItem.data) {
        this.otRequestItem = otRequestItem.data
      }

      this.loading = false
    },
    async shift_import () {
      this.dataReady = true
      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      this.dayMin = moment().subtract(3, 'd').format('D')
      this.monthMin = moment().format('M')

      this.currentMonth = moment().format('M')

      var currentDate = moment().format('YYYY-MM-DD')
      var currentThreeTHDate =
        moment().format('YYYY') + '-' + moment().format('MM') + '-03'
      var convertThreeTHDate = moment(currentThreeTHDate).format('YYYY-MM-DD')
      this.shifttem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeShiftMonth?empCode=' +
            this.profile.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.shifttem = response.data
          this.shifttem.forEach((shifttem) => {
            const result = this.otRequestItem.filter(
              (ot) =>
                ot.ot_year === shifttem.shiftYear &&
                ot.ot_month === shifttem.shiftMonth &&
                ot.ot_day === shifttem.shiftDay
            )
            // เงือนไขซ่อนปุ่ม
            shifttem.beforeCheckShiftCheckin = true
            if (currentDate > shifttem.shiftDate) {
              // ถ้าไม่มี Check IN OUT ให้ซ่อนปุ่ม
              if (!shifttem.checkInStartStamp && !shifttem.checkInEndStamp) {
                shifttem.beforeCheckShiftCheckin = false
              }
              // ถ้ามี Check IN แต่ สาย ให้ซ่อนปุ่ม
              var masShiftTypeStartTime = new Date(`${currentDate} ${shifttem.masShiftTypeStartTime}`)
              var checkInStartStamp = new Date(`${currentDate} ${shifttem.checkInStartStamp}`)
              if (shifttem.checkInStartStamp && masShiftTypeStartTime < checkInStartStamp) {
                shifttem.beforeCheckShiftCheckin = false
              }
              // ต้องมี Check IN และ Check Out
              if (shifttem.checkInStartStamp && shifttem.checkInEndStamp) {
                shifttem.beforeCheckShiftCheckin = true
              }
            }

            shifttem.checkBeforeMonth = true
            if (shifttem.shiftMonth < this.currentMonth) {
              if (currentDate > convertThreeTHDate) {
                shifttem.checkBeforeMonth = false
              }
            }
            shifttem.request_status = result.length > 0
            shifttem.ot_status = result.length > 0 ? result[0].status : null
            shifttem.check_cant_request_status =
              result.length > 0 ? result[0].check_cant_request_status : null

            if (shifttem.checkInStartStamp) {
              shifttem.colorout = 'green'

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = null
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.detail = shifttem.leave
                shifttem.checkInStartStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInStartStamp
                shifttem.checkInEndStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInEndStamp
                shifttem.colorin =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorin
                shifttem.colorout =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.detail = shifttem.leave
                  shifttem.checkInStartStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.colorin =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                  shifttem.colorout =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                } else {
                  shifttem.checkInStartStamp = null
                  shifttem.checkInEndStamp = null
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
            this.dataReady = false
          })
          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
/* .v-card { touch-action: pan-y !important; }
.touch-pan-y {
  touch-action: pan-y !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/Liff/OTRequest.vue